// eslint-disable-next-line import/prefer-default-export
export const DAY_PERCENTAGES = {
  morningDiscountPercentage: 0,
  afternoonDiscountPercentage: 0,
  eveningDiscountPercentage: 0,
};
